//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicantAvatar",
  components: {
    ProfileAvatar
  },
  props: {
    clientDetails: {
      type: Object,
      required: true
    },
    registered: {
      type: Boolean,
      default: false
    },
    avatarInitials: {
      type: String,
      required: true
    },
    verified: {
      type: Boolean,
      default: false
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    registrationIcon() {
      return this.verified || !this.pending ? "check-circle" : "question-circle";
    },
    registrationIconColor() {
      return this.verified || !this.pending ? "text-success" : "text-light-gray";
    },
    tooltipMessage() {
      if (this.verified) return this.$t("global.messages.clientIsRegisteredInPlatform");
      if (!this.pending) return this.$t("global.messages.clientIsRegisteredButNotValidate");
      if (this.registered) return this.$t("global.messages.clientIsRegisteredButNotSubmittedApp");
      return this.$t("global.messages.clientIsNotRegisteredInPlatform");
    }
  }
});